import './Button.css';

const Button = ({ children, variant, onClick, className }) => {
  return (
    <button 
      className={`btn ${variant || 'primary'} ${className || ''}`} 
      onClick={onClick}
    >
      {children}
    </button>
  );
};

export default Button;